import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class CreditInvoiceSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "invoiceId";
    }

  /*  override isEntityLocalisable(): boolean {
        return false;
    }*/
}
